module.exports = __webpack_public_path__ + "img/insurance-qr-code.57e26931.png";